<template>
  <div>
    <div class="customRow">
      <div class="column-5">
        <div class="header">
          <h5>Download Template</h5>
        </div>
        <a target="_blank" href="/static-contents/ChannelOrderTemplate.xlsx">
          <div class="bordered-box">
            <font-awesome-icon
              :icon="['far', 'cloud-arrow-down']"
              style="font-size: 128px; color: gray"
            />
          </div>
        </a>
      </div>
      <div class="column-5">
        <div class="header">
          <h5>Upload Channel List</h5>
        </div>
        <div class="bordered-box">
          <font-awesome-icon
            :icon="['far', 'cloud-arrow-up']"
            style="font-size: 128px; color: gray"
            class="pointer"
            @click="showFileUploader()"
          />
        </div>
      </div>
    </div>
    <div>
      <div class="padding-bottom">
        <input
          type="file"
          id="sitesUploadInputControl"
          class="hidden"
          onclick="this.value=null;"
        />
      </div>
    </div>
    <!-- ExcelColumnMapper Popup starts-->
    <div>
      <customModal
        id="excelColMapperModalContainer"
        title="Match Uploaded Columns to our Data"
        :show.sync="showExcelMapper"
        :centered="true"
        :backdrop="true"
        :closeOnBackdrop="false"
        width="35%"
        :CCRColoBrand="true"
      >
        <ExcelColumnMapper
          v-if="showExcelMapper"
          @hide-modal="showExcelMapper = false"
          :CustomExcelColumn="CustomExcelColumn"
          @set-excel-columns="setExcelCustomColumns"
        />
      </customModal>
    </div>
    <!-- ExcelColumnMapper Popup ends-->
    <DxLoadPanel
      :position="loaderPosition"
      :visible.sync="loaderVisible"
      :show-indicator="true"
    />
  </div>
</template>
<script>
import { DxLoadPanel } from "devextreme-vue/load-panel";
import readXlsxFile from "read-excel-file";
import notify from "devextreme/ui/notify";
import ExcelColumnMapper from "../../../views/placeAnOrderRequest/ExcelColumnMapper.vue";
export default {
  name: "PlaceAnOrder",
  components: {
    DxLoadPanel,
    ExcelColumnMapper,
  },
  data() {
    return {
      loaderPosition: { of: ".excelImport" },
      loaderVisible: false,
      importedExcelData: [],
      rawExcelData: [],
      CustomExcelColumn: [],
      showExcelMapper: false,
      defaultColumns: [
        "Channel Requested Name",
        "DMA Rec ID",
        "DSrcID",
        "CM Medium RecID",
      ],
      ExcelIndex: {
        ChannelRequestedName: 0,
        DMA_RecID: 1,
        DSrcID: 2,
        CM_Medium_RecID: 3,
      },
    };
  },
  mounted: function () {
    let th = this;
    let input = document.getElementById("sitesUploadInputControl");
    input.addEventListener("change", () => {
      th.loaderVisible = true;
      readXlsxFile(input.files[0]).then((rows) => {
        th.importedExcelData = [];
        th.rawExcelData = [];
        th.rawExcelData = rows;
        th.checkCustomColumns(rows);
        th.loaderVisible = false;
      });
    });
  },
  methods: {
    showFileUploader() {
      document.getElementById("sitesUploadInputControl").click();
    },
    checkCustomColumns(rows) {
      let th = this;
      // if (JSON.stringify(rows[0]) != JSON.stringify(this.defaultColumns)) {
      //   notify(
      //     {
      //       message: "Not valid",
      //       position: {
      //         my: "center top",
      //         at: "center top",
      //       },
      //       width: "300px",
      //     },
      //     "error",
      //     5000
      //   );
      //   return; 
      // } else {
        // If not default CCR template ,show columns mapper modal
        if (JSON.stringify(rows[0]) != JSON.stringify(this.defaultColumns)) {
          this.CustomExcelColumn = rows[0];
          this.showExcelMapper = true;
        } else {
          //process data
          th.processExcelData(rows, 1);
        }
    },
    setExcelCustomColumns(excelIndex) {
      console.log(excelIndex);
      let th = this;
      this.ExcelIndex = {};
      this.ExcelIndex = excelIndex;
        th.processExcelData(th.rawExcelData, 1);
    },
    // validateStep() {
    //   let counter = 0;
    //   let disabledTooltipMsgs = [];
    //   if (this.importedExcelData.length === 0) {
    //     counter++;
    //     disabledTooltipMsgs.push("Upload List of Products to Continue");
    //   }
    //   if (counter === 0)
    //     this.$emit("set-imported-products", this.importedExcelData);
    //   return counter === 0;
    // },
    processExcelData(array, startRowDataIndex) {
      let th = this;
      this.loaderVisible = true;
      let temp = [];
      if (array.length > 0) {
        array.slice(startRowDataIndex).forEach((rowData, k) => {
          if (!rowData[k]) rowData[k] = null;
          let jsonObj = {};
          jsonObj = {
            //RowID: k + 1, Unique ID for row
            RequestedDate : (new Date()).toISOString(),
            ChannelName:
              th.ExcelIndex.ChannelRequestedName != undefined
                ? rowData[th.ExcelIndex.ChannelRequestedName]
                : null,
            DMA_RecID:
              th.ExcelIndex.DMA_RecID != undefined
                ? rowData[th.ExcelIndex.DMA_RecID]
                : null,
            NielsenDistributionID:
              th.ExcelIndex.DSrcID != undefined
                ? rowData[th.ExcelIndex.DSrcID]
                : null,
            CM_Medium_RecID:
              th.ExcelIndex.CM_Medium_RecID != undefined
                ? rowData[th.ExcelIndex.CM_Medium_RecID]
                : null,
          };
          th.importedExcelData.push(jsonObj);
          temp.push(k);
          if (temp.length === array.length - 1) {
            th.$emit("set-imported-products", th.importedExcelData);
            th.loaderVisible = false;
            th.$emit("show-next-step");
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.hidden {
  display: none;
}
.customRow {
  display: flex;
  width: 100%;
}
.column-5 {
  width: 50.00%;
  padding: 4%;
}
.header {
  color: #fff;
  background-color: #636466;
  height: 30px;
  padding: 5px 10px;
  border-bottom: none;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-sizing: border-box;

  h5 {
    font-size: 16px;
  }
}
.bordered-box {
  border: 1px solid #ddd;
  padding: 30px;
  color: #333333;
  border-radius: 0px 0px 5px 5px;
  height: 200px;
  text-align: center;
  cursor: pointer;
}
</style>